window.__assetPrefix__ = 'https://dxsf06ywkpbfz.cloudfront.net/vercel-frontend-notifications-center';